import { createAsyncThunk } from '@reduxjs/toolkit';
import { UsersGetProfileResponse } from 'types/swagger';

interface ActivateContractPayload {
  pinCode: string;
  contractCode: string;
}

export const activateContract = createAsyncThunk<UsersGetProfileResponse, ActivateContractPayload>(
  'activateContract',
  async ({ pinCode, contractCode }) => {
    try {
      const response = await fetch(`/api/auth/contractActivate`, {
        method: 'POST',
        body: JSON.stringify({
          username: contractCode,
          password: pinCode,
        }),
      }).then(async (e) => {
        const result = (await e.json()) as UsersGetProfileResponse;
        return result;
      });

      return Promise.resolve(response);
    } catch (e) {
      return Promise.reject();
    }
  }
);
